module.exports = __webpack_public_path__ + "d664201f/img/arrow-export-icon.a3345173.svg";